export const uvIndexColors = {
  1: "#22c55e",
  2: "#bef264",
  3: "#fde047",
  4: "#f59e0b",
  5: "#f97316",
  6: "#c2410c",
  7: "#ef4444",
  8: "#b91c1c",
  9: "#ec4899",
  10: "#d946ef",
};
